export default __webpack_public_path__ + "static/media/Whoweare.e0ded084.svg";